const moment = require('moment');

export default projectEdges =>
  (projectEdges || [])
    .map(({ node }) => ({
      path: node.fields.slug,
      tags: node.frontmatter.tags,
      cover: node.frontmatter.cover,
      color: node.frontmatter.color,
      title: node.frontmatter.title,
      client: node.frontmatter.client,
      date: moment(node.frontmatter.date, 'DD/MM/YYYY').toDate()
    }))
    .sort((a, b) => {
      if (moment(a.date).isSame(b.date)) {
        return 0;
      }
      return moment(a.date).isBefore(b.date) ? 1 : -1;
    });



// WEBPACK FOOTER //
// ./src/shared/getWorks.js